var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('i',{staticClass:"icon icon-spinner delayed-loader"}):_c('span',[_vm._v(_vm._s(_vm.restarts))])}
var staticRenderFns = []

export { render, staticRenderFns }